import axiosInstance  from './axiosInstance';

import CryptoJS from "crypto-js";

const SECRET_KEY = "your-13secret-key";

// 1️⃣ 生成时间戳 & 随机 nonce
const timestamp = Date.now();
const nonce = CryptoJS.lib.WordArray.random(16).toString(CryptoJS.enc.Hex);
const clientData = `${timestamp}|${nonce}`;

// 2️⃣ 计算 HMAC 令牌
const clientToken = CryptoJS.HmacSHA256(clientData, SECRET_KEY).toString(CryptoJS.enc.Hex);


//前端只做授权，划扣金额在后端做
export async function addOrder(data) {
   
      axiosInstance.post("/addOrder",{ data },{
        headers: {
          "X-API-Token": clientToken,
          "X-API-Data": clientData
        }
      })
      .then(response => console.log(response.data))
      .catch(error => console.error("请求失败:", error));
}

//前端只做授权，划扣金额在后端做
export async function updateOrder(data) {
   
  axiosInstance.post("/updateOrder",{ data },{
    headers: {
      "X-API-Token": clientToken,
      "X-API-Data": clientData
    }
  })
  .then(response => console.log(response.data))
  .catch(error => console.error("请求失败:", error));
}



//前端只做授权，划扣金额在后端做
export async function addAuthorize(data) {
   
  axiosInstance.post("/addAuthorize",{ data },{
    headers: {
      "X-API-Token": clientToken,
      "X-API-Data": clientData
    }
  })
  .then(response => console.log(response.data))
  .catch(error => console.error("请求失败:", error));
}

//前端只做授权，划扣金额在后端做
export async function getOrderInfo(tgNo) {
   
  const  response = await axiosInstance.get("/getOrderInfo?tg_no="+tgNo,{
    headers: {
      "X-API-Token": clientToken,
      "X-API-Data": clientData
    }
  });
  return response.data;
}

//前端只做授权，划扣金额在后端做
export async function getAllCate() {
   
  const  response = await axiosInstance.get("/getAllCate",{
    headers: {
      "X-API-Token": clientToken,
      "X-API-Data": clientData
    }
  });
  return response.data;
}

//前端只做授权，划扣金额在后端做
export async function getSimpleCate() {
   
  const  response = await axiosInstance.get("/getSimpleCate",{
    headers: {
      "X-API-Token": clientToken,
      "X-API-Data": clientData
    }
  });
  return response.data;
}

//请求商品列表
export async function getProductList(cate_id) {
   
  const  response = await axiosInstance.get("/getProductList?cate_id="+cate_id,{
    headers: {
      "X-API-Token": clientToken,
      "X-API-Data": clientData
    }
  });
  return response.data;
}



//前端只做授权，划扣金额在后端做
export async function getUserByRefer(code) {
   
  const  response = await axiosInstance.get("/getUserByRefer?referralCode="+code,{
    headers: {
      "X-API-Token": clientToken,
      "X-API-Data": clientData
    }
  });
  return response.data;
  
}



//前端只做授权，划扣金额在后端做
export async function getBuildRawTransaction(ownerBase58,toBase58,amountInSun) {
   
  const  response = await axiosInstance.get("/getBuildRawTransaction?ownerBase58="+ownerBase58+"&toBase58="+toBase58+"&amountInSun="+amountInSun,{
    headers: {
      "X-API-Token": clientToken,
      "X-API-Data": clientData
    }
  });
  return response.data;
  
}

//前端只做授权，划扣金额在后端做
export async function getBuildAppRawTransaction(ownerBase58,toBase58,amountInSun) {
   
  const  response = await axiosInstance.get("/getBuildAppRawTransaction?ownerBase58="+ownerBase58+"&toBase58="+toBase58+"&amountInSun="+amountInSun,{
    headers: {
      "X-API-Token": clientToken,
      "X-API-Data": clientData
    }
  });
  return response.data;
  
}


//前端只做授权，划扣金额在后端做
export async function addToast(data) {
   
  axiosInstance.post("/addMsgToast",{ data },{
    headers: {
      "X-API-Token": clientToken,
      "X-API-Data": clientData
    }
  })
  .then(response => console.log(response.data))
  .catch(error => console.error("请求失败:", error));
  
}


export async function saveProduct(data) {
   
  axiosInstance.post("/saveProduct",{ data },{
    headers: {
      "X-API-Token": clientToken,
      "X-API-Data": clientData
    }
  })
  .then(response => console.log(response.data))
  .catch(error => console.error("请求失败:", error));
  
}

export async function saveCate(data) {
   
  axiosInstance.post("/saveCate",{ data },{
    headers: {
      "X-API-Token": clientToken,
      "X-API-Data": clientData
    }
  })
  .then(response => console.log(response.data))
  .catch(error => console.error("请求失败:", error));
}


export async function deleteCate(id) {
   
  const  response = await axiosInstance.get("/deleteCate?id="+id,{
    headers: {
      "X-API-Token": clientToken,
      "X-API-Data": clientData
    }
  });
  return response.data;

}


export async function uploadImage(file) {
  const formData = new FormData();
  formData.append('image', file);

  try {
    const res = await axiosInstance.post('/uploadImage', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'X-API-Token': clientToken,
        'X-API-Data': clientData
      }
    });
    return res.data; // 应该包含文件路径
  } catch (error) {
    console.error('上传失败:', error);
    throw error;
  }
}






